import classNames from 'classnames'
import { memo } from 'react'

import style from './HowWorkCard.module.scss'
import { HowWorkCardType } from './howWorkMock'

// карточка в блоке "как это работает?"
export const HowWorkCard = memo(
  ({ pic, num, header, text }: HowWorkCardType) => (
    <div className={classNames(style.card, style[`card-${num}`])}>
      {pic}
      <div className={style.header}>
        <div className={style.number}>{num}</div>
        <p className='h2'>{header}</p>
      </div>
      <p className={style.text}>{text}</p>
    </div>
  ),
)
